import PeopleCard from './PeopleCard';

export { type PeopleCardProps } from './PeopleCard';
export default PeopleCard;
